import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from "swiper";
Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);
import "swiper/css";

export const Home = () => {
  const mvSwiper = new Swiper(".js-mv-swiper", {
    loop: true,
    effect: "fade",
    speed: 1000,

    autoplay: {
      delay: 3000,
    },
  });

  const infoSwiper = new Swiper(".js-info-swiper", {
    slidesPerView: 1.1,
    spaceBetween: 27,
    speed: 700,
    loop: true,
    centeredSlides: true,

    autoplay: {
      delay: 3000,
    },

    pagination: {
      el: ".js-info-pagination",
      clickable: true,
    },

    breakpoints: {
      540: {
        slidesPerView: 1.5,
      },

      768: {
        slidesPerView: 2,
      },

      992: {
        slidesPerView: 3,
      },
    },
  });

  const voiceSwiper = new Swiper(".js-voice-swiper", {
    slidesPerView: 1.05,
    spaceBetween: 15,
    speed: 700,
    loop: true,
    centeredSlides: true,

    navigation: {
      prevEl: ".js-voice-prev",
      nextEl: ".js-voice-next",
    },

    breakpoints: {
      540: {
        slidesPerView: 1.3,
      },
      768: {
        slidesPerView: 1.5,
      },
      992: {
        slidesPerView: 2.5,
      },
      1060: {
        slidesPerView: 3,
      },
    },
  });

  const newsSwiper = new Swiper(".js-news-swiper", {
    slidesPerView: 1,
    speed: 700,
    loop: true,
    direction: "vertical",
    centeredSlides: true,
    spaceBetween: 5,

    autoplay: {
      delay: 2000,
    },
  });
};
